export const getUrlKey = (name) => {
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
        location.href
      ) || [, ""])[1].replace(/\+/g, "%20")
    ) || null
  );
};

export const checkBtn = (btnList) => {
  // 1. 默认常用权限，兼容老代码
  const defaultKeys = [
    "search",
    "insert",
    "update",
    "delete",
    "updateStatus",
    "import",
    "export",
    "exportTemplate",
    "updatePack",
    "importProduct",
    "exportTemplateProduct",
    "importPack",
    "exportTemplatePack",
    "exportProduct",
    "updatePlan",
    "exportExceptionCode",
    "updatePassword",
    "empty",
    "fastSearch",
  ];
  // 2. 先全部置为false
  let promiseBtn = {};
  defaultKeys.forEach((key) => (promiseBtn[key] = false));

  // 3. 动态处理后端返回的所有权限
  btnList.forEach((item) => {
    if (item.permission) {
      promiseBtn[item.permission] = !!item.checked;
    }
  });

  return promiseBtn;
};



// WEBPACK FOOTER //
// ./src/utils/methods.js